import React, { useEffect, useState } from 'react'
import { Table } from 'react-bootstrap'
import { doorSensorAwsApi } from '../common/ApiCall'
import moment from 'moment'
import Loading from '../common/Loading'
import { findDatesBetween } from '../redux/action/dailyUnit'
import ChartHeader from '../Chart/ChartHeader'
import { images } from '../common/images'

function EnergiSychOccupancyLogs({ data, multipleDayData }) {
    const [error, setError] = useState('')
    let [openSessions, setOpenSessions] = useState([])
    let [loading, setLoading] = useState(false)
    useEffect(() => {
        if (multipleDayData?.length > 0) {
            let dataLogs = []
            for (let dayData of multipleDayData) {
                if (dayData?.occupancyLogs && Array.isArray(dayData.occupancyLogs)) {
                    dataLogs = [...dataLogs, ...dayData.occupancyLogs]
                }
            }
            if (dataLogs.length > 0) {
                setOpenSessions(dataLogs)
                setError('')
            } else {
                setOpenSessions([])
                setError('No data found')
            }
        } else {
            setError('No data found')
             setOpenSessions([])
        }
    }, [multipleDayData])
    function formatDuration(ms) {
        const totalSeconds = Math.floor(ms / 1000);

        const hours = String(Math.floor(totalSeconds / 3600)).padStart(2, '0');
        const minutes = String(Math.floor((totalSeconds % 3600) / 60)).padStart(2, '0');
        const seconds = String(totalSeconds % 60).padStart(2, '0');

        return `${hours}:${minutes}:${seconds}`;
    }
    return (
        <div className=''>
            <ChartHeader
                name="System OnTime Logs"
                image={images.calendar}
                textColor={"#322FC8"}
                iconBackgroundColor={"rgba(50, 47, 200, 0.10)"}
            />
            {loading && <Loading />}
            <div className='overflow-scroll' style={{ maxHeight: '200px' }}>
                <Table hover striped>
                    <thead>
                        <tr>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Duration</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            openSessions?.map((session, index) => {
                                return (
                                    <tr key={index}>
                                        <td>{moment(session?.st).format('DD MMM YYYY, LT')}</td>
                                        <td>{moment(session?.et).format('DD MMM YYYY, LT')}</td>
                                        <td>{formatDuration(session?.et - session?.st)}</td>
                                    </tr>
                                )
                            })
                        }
                        {error && <tr><td colSpan={3}>{error}</td></tr>}
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

export default EnergiSychOccupancyLogs
